import { Component, Injectable, Input, NgZone, OnInit } from '@angular/core';
import { filter } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
// import { ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerConfig, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { DateService } from 'src/app/services/date.service';
import { facilityService } from 'src/app/services/facility.service';
import { SidenavService } from 'src/app/services/sidenav.service';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter, NgbModalOptions, NgbActiveModal, NgbDateStruct, NgbDateParserFormatter, NgbDateNativeAdapter, NgbDatepicker, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { CancelMeetingroomBooking } from 'src/app/modal/cancel-meetingroom-booking/cancel-meetingroom-booking.component';
import { BookNewMeetingRoomComponent } from 'src/app/modal/book-new-meeting-room/book-new-meeting-room.component';
import { MeetingService } from 'src/app/services/meeting.service';

@Injectable()
export class CustomAdapter extends NgbDateAdapter<string> {
  readonly DELIMITER = '-';

  fromModel(value: string | null): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  toModel(date: NgbDateStruct | null): string | null {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : null;
  }
}

/**
 * This Service handles how the date is rendered and parsed from keyboard i.e. in the bound input field.
 */
@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '/';

  parse(value: string): NgbDateStruct | null {
    if (value) {
      let date = value.split(this.DELIMITER);
      return {
        day: parseInt(date[0], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[2], 10),
      };
    }
    return null;
  }

  format(date: NgbDateStruct | null): string {
    return date
      ? date.day + this.DELIMITER + date.month + this.DELIMITER + date.year
      : '';
  }
}

@Component({
  standalone: false,
  selector: 'app-view-blocked-meeting-room',
  templateUrl: './view-blocked-meeting-room.component.html',
  styleUrls: ['./view-blocked-meeting-room.component.scss']
})
export class ViewBlockedMeetingRoomComponent implements OnInit {
  @Input() list;
  toDate: Date;
  selectAll: boolean = false;
  selectedToDate: any;
  tDate: any;
  formattedSelectedToDate: any;
  companyList: any;
  multiSelectionCompanyName: any = [];
  selectedCompanyName: any;
  selctionlength: number;
  selectedId: any;
  page: any = 1;
  tempHistoryList: any = [];
  pageSize: number = 10;
  tempDate: any;
  totalCount: any;
  BookingStatus: any = [
    { statusText: 'Confirmed', statusValue: true },
    { statusText: 'Cancelled', statusValue: false },
  ];
  openOptionDrawer: boolean = false;
  BookingStatusText: any;
  BookStatusValue: any;
  meetingRoomBookedDetails: any;
  meetingRoomId: any;
  meetingRoomName: string;
  tempTime: any;
  closeResult: string;
  disbursePoints: number = undefined;
  bookingId: any;
  multiSelectBookingId: any = [];
  singleBooking: boolean;
  tempMeetingRoomDetail: any[] = [];
  meetingNav: { index: string; name: string; link: string }[];
  meetingRoomAlreadyBlockDetails = [];
  BookingStatusTextTemp: any;

  //pagination
  // pageSize = 10;
  pageNo = 1;
  // totalCount = 0;
  displayCount = 0;
  totalCountList: number = 0;
  fromDate: any;
  selectedFromDate: any;
  formattedSelectedFromDate: any;
  fDate: any;

  constructor(
    private router: Router,
    public datepipe: DatePipe,
    private appStateSrv: AppStateProvider,
    private zone: NgZone,
    private dateAdapter: NgbDateAdapter<string>,
    private ngbCalendar: NgbCalendar,
    private ngbDatepickerConfig: NgbDatepickerConfig,
    private dateSrv: DateService,
    private apiSrvice: facilityService,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private sideNavService: SidenavService,
    private meetingService: MeetingService,
  ) {
    ngbDatepickerConfig.outsideDays = 'visible';
  }

  ngOnInit(): void {
    this.meetingRoomName = localStorage.getItem('viewMeetingRoomName');
    this.activatedRoute.queryParams.subscribe((res) => {
      this.meetingRoomId = res.meetingRoomId;
    });

    const jsDate = new Date();
    this.BookingStatusText = this.BookingStatus[0].statusText;
    this.BookingStatusTextTemp = this.BookingStatus[0].statusText;
    this.BookStatusValue = this.BookingStatus[0].statusValue;

    this.selectedToDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');
    this.selectedFromDate = this.datepipe.transform(jsDate, 'MM/dd/yyyy');

    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );
    this.formattedSelectedFromDate = this.dateSrv.convertDateToLocaleString(
      new Date().getDate(),
      new Date().getMonth(),
      new Date().getFullYear()
    );

    this.getMeetingRoomBlockedDetails();
  }

  compareDate(date) {
    return new Date(date) > new Date() ? true : false
  }

  setStatus(item) {
    console.log(item);
    this.BookingStatusText = item.statusText;
    this.BookingStatusTextTemp = item.statusText;
    this.BookStatusValue = item.statusValue;
    this.getMeetingRoomBlockedDetails();
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  openPopover(popover, id) {
    this.singleBooking = false;
    this.disbursePoints = undefined;

    if (id !== 0) {
      this.singleBooking = true;
      this.bookingId = id;
    }
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  formatDateToString(dateString) {
    const [month, day, year] = dateString.split('/'); // Split the date string into components

    // Ensure day and month have leading zeros if needed
    const formattedDay = day.padStart(2, '0');
    const formattedMonth = month.padStart(2, '0');

    return `${formattedMonth}/${formattedDay}/${year}`; // Format and concatenate components
  }

  public async updateSelectedToDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.toDate = jsDate;
    this.selectedToDate = this.formatDateToString(this.datepipe.transform(jsDate, 'MM/dd/yyyy'));
    this.formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );
    this.getMeetingRoomBlockedDetails();
  }

  public async updateSelectedFromDate(date: NgbDate) {
    const jsDate = new Date(date.year, date.month - 1, date.day);
    const delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.fromDate = jsDate;
    this.selectedFromDate = this.formatDateToString(this.datepipe.transform(jsDate, 'MM/dd/yyyy'));
    this.formattedSelectedFromDate = this.dateSrv.convertDateToLocaleString(
      date.day,
      date.month - 1,
      date.year
    );

    // let newToDate = new Date(this.selectedFromDate);
    // newToDate.setDate(newToDate.getDate() + 1);
    // this.selectedToDate = (newToDate.getMonth() + 1) + '/' + newToDate.getDate() + '/' + newToDate.getFullYear();
    // let updatedDateObj = new Date(this.selectedToDate);
    // let formattedSelectedToDate = this.dateSrv.convertDateToLocaleString(
    //   updatedDateObj.getDate(),
    //   updatedDateObj.getMonth(),
    //   updatedDateObj.getFullYear()
    // );
    // this.formattedSelectedToDate = formattedSelectedToDate;

    this.getMeetingRoomBlockedDetails();
  }

  // handlePageChange(event) {
  //   console.log(event);
  //   this.page = event;
  // }

  formatDate(date) {
    if (date == null) return;
    this.tempDate = date.split('T')[0].split('-');
    return this.dateSrv.convertDateToLocaleString(
      this.tempDate[2],
      this.tempDate[1] - 1,
      this.tempDate[0]
    );
  }

  formatTime(time) {
    if (time == null) return;
    // console.log(time);
    this.tempTime = time.split('T')[1].split(':');
    if (this.tempTime[0] == 12) {
      return this.tempTime[0] + ':' + this.tempTime[1] + 'PM'
    }
    else {
      return this.tempTime[0] > 12
        ? this.tempTime[0] - 12 + ':' + this.tempTime[1] + 'PM'
        : this.tempTime[0] + ':' + this.tempTime[1] + 'AM';
    }
  }

  open(content) {
    console.log('open modal', this.bookingId);
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-class',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  close(content) {
    // this.disbursePoints=0;
    this.modalService.dismissAll();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  disburse() {
    const data = {
      bookingId: this.bookingId,
      amount: this.disbursePoints,
    };
    console.log(data);
    this.apiSrvice.disburseDeposit(data).subscribe((res) => {
      console.log(res);
      if (res?.isValid == true) {
        this.getMeetingRoomBlockedDetails()
      }
      this.disbursePoints = undefined;
    });
  }

  cancelBooking(caledarId) {
    this.BookingStatusTextTemp = 'Confirmed';
    console.log("cancel", caledarId);
    this.apiSrvice.cancelBlockedFacility(caledarId).subscribe((res) => {
      console.log(res);
      // if (res?.isValid == true) {
      //   this.getMeetingRoomBlockedDetails()
      // }
      this.getMeetingRoomBlockedDetails();
      // location.reload();
    });
  }

  editBlocking(caledarId, startDateTime, endDateTime, purpose, remarks, bookingType, userId) {

    localStorage.setItem('roomCalendarBlockoutId', caledarId);

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(BookNewMeetingRoomComponent, modalOptions);
    modalRef.componentInstance.parkMeetingRoomId = this.meetingRoomId;
    modalRef.componentInstance.userId = localStorage.getItem('claAdminId');
    modalRef.componentInstance.meetingDayFromName = localStorage.getItem('meetingOperationFromDay');
    modalRef.componentInstance.meetingDayToName = localStorage.getItem('meetingOperationToDay');
    modalRef.componentInstance.meetingRoomStartTime = localStorage.getItem('meetingmaintainenceStartTime');
    modalRef.componentInstance.meetingRoomEndTime = localStorage.getItem('meetingmaintainenceEndTime');
    modalRef.componentInstance.maintainenceStartDate = localStorage.getItem('meetingmaintainenceStartDate');
    modalRef.componentInstance.maintainenceEndDate = localStorage.getItem('meetingmaintainenceEndDate');
    modalRef.componentInstance.isMeetingRoomEdit = 'yes';
    modalRef.componentInstance.bookedStartDateTime = startDateTime;
    modalRef.componentInstance.bookedEndDateTime = endDateTime;
    modalRef.componentInstance.purpose = purpose;
    modalRef.componentInstance.remarks = remarks;
    modalRef.componentInstance.bookingTypeHourDaily = bookingType;
    modalRef.componentInstance.bookedByUserId = userId;
  }

  formatDateForBlocking(date, type) {
    if (date == null) return;
    if (type == 'date') {
      this.tempDate = date.split('T')[0].split('-');
      return this.dateSrv.convertDateToLocaleString(this.tempDate[2], this.tempDate[1] - 1, this.tempDate[0]);
    }
    else {
      this.tempDate = date.split('T')[1].split(':');
      let type = this.tempDate[0] <= 12 ? 'AM' : 'PM';
      return (this.tempDate[0] > 12) ? this.tempDate[0] - 12 + ':' + this.tempDate[1] + ' ' + type : this.tempDate[0] + ':' + this.tempDate[1] + ' ' + type;

    }
  }

  navigateToDetail() {
    this.router.navigate(['/meeting-room/details-meeting-room'], {
      queryParams: {
        id: this.meetingRoomId,
      },
    });
  }

  toggleSelectAllSelection(show) {
    this.multiSelectBookingId = [];
    if (this.selectAll) {
      this.tempMeetingRoomDetail = this.meetingRoomBookedDetails.filter(el => new Date(el?.startDateTime) > new Date())
      console.log("select all", this.tempMeetingRoomDetail)
      this.tempMeetingRoomDetail.forEach((element) => {
        this.multiSelectBookingId.push(element.roomCalendarBlockoutId);
      });
    } else {
      this.multiSelectBookingId = [];
    }
    console.log('iddd', this.multiSelectBookingId);
    return this.multiSelectBookingId;
  }

  toggleSelection(show, id) {
    if (this.multiSelectBookingId.includes(id)) {
      this.multiSelectBookingId.splice(
        this.multiSelectBookingId.indexOf(id),
        1
      );
    } else {
      this.multiSelectBookingId.push(id);
    }

    this.selectAll =
      this.meetingRoomBookedDetails.length == this.multiSelectBookingId.length
        ? true
        : false;
    console.log('ifff', this.multiSelectBookingId);

    return this.multiSelectBookingId;
  }

  convertToDateFormat(dateString) {
    // Split the input date string into month, day, and year
    let [month, day, year] = dateString.split('/');

    // Add leading zeros if necessary
    month = month.padStart(2, '0');
    day = day.padStart(2, '0');

    // Return the date in YYYY-MM-DD format
    return `${year}-${month}-${day}`;
  }


  getMeetingRoomBlockedDetails() {
    console.log(this.BookingStatusTextTemp);
    if (this.BookingStatusTextTemp == 'Confirmed' || this.BookingStatusTextTemp == 'Confirm') {
      this.BookingStatusTextTemp = 'Confirm';
    } else {
      this.BookingStatusTextTemp = 'Cancel';
    }
    this.meetingRoomAlreadyBlockDetails = [];
    this.meetingRoomAlreadyBlockDetails.push({
      parkMeetingRoomId: this.meetingRoomId,
      getType: this.BookingStatusTextTemp,
      pageNo: this.pageNo,
      size: this.pageSize,
      startDateTime: this.convertToDateFormat(this.selectedFromDate),
      endDateTime: this.convertToDateFormat(this.selectedToDate)
    });
    this.meetingService
      .getAllMeetingRoomBlockData(this.meetingRoomAlreadyBlockDetails[0])
      .subscribe((res) => {
        this.meetingRoomBookedDetails = res?.list;
        this.totalCountList = res?.list.length;
      });
  }

  fetchPage(val) {
    return val % 10 == 0 ? Math.floor(val / 10) : Math.floor(val / 10) + 1;
  }

  handlePageChange($event) {
    this.pageNo = $event;
    this.getMeetingRoomBlockedDetails();
  }

  cancelMeetingRoomBooking(calendarId) {

    const modalOptions: NgbModalOptions = {
      size: 'md',
    };

    const modalRef = this.modalService.open(CancelMeetingroomBooking, modalOptions);
    modalRef.componentInstance.meetingRoomId = calendarId;
  }
}


